function formatDateTime(value) {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "-";
  return new Intl.DateTimeFormat("nl-NL", {
    dateStyle: "medium",
    timeStyle: "short",
  }).format(date);
}

function stripHtml(value) {
  return String(value || "").replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();
}

function labelForDirection(direction) {
  if (direction === "incoming") return "Inkomend";
  if (direction === "outgoing") return "Uitgaand";
  if (direction === "internal_note") return "Interne notitie";
  return "Bericht";
}

export default function CommunicationMessageCard({ message }) {
  const body = String(message?.bodyText || "").trim() || stripHtml(message?.bodyHtml);
  const fromLabel = [message?.from?.name, message?.from?.email].filter(Boolean).join(" • ") || "Onbekende afzender";

  return (
    <article className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
      <div className="flex flex-wrap items-start justify-between gap-2">
        <div>
          <p className="text-xs uppercase tracking-wide text-slate-500">{labelForDirection(message?.direction)}</p>
          <p className="mt-1 text-sm font-medium text-slate-900">{fromLabel}</p>
        </div>
        <p className="text-xs text-slate-500">{formatDateTime(message?.createdAt)}</p>
      </div>

      {message?.subject ? <p className="mt-3 text-sm font-medium text-slate-800">{message.subject}</p> : null}
      <p className="mt-2 whitespace-pre-wrap text-sm leading-6 text-slate-700">{body || "Geen inhoud."}</p>

      {Array.isArray(message?.to) && message.to.length > 0 ? (
        <p className="mt-3 text-xs text-slate-500">
          Aan: {message.to.map((item) => item?.name || item?.email).filter(Boolean).join(", ")}
        </p>
      ) : null}
    </article>
  );
}
